import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { noop } from '../../../../default-props/noop';
import { emptyArray } from 'ui-components/default-props/empty';
import { Button } from '../../../button';

import style from './tab-button.module.less';

export const DeprecatedTabButton = ({
  id = '',
  selected = false,
  onClick = noop,
  className = '',
  children = emptyArray,
  selectedClassName = '',
  theme = 'unstyled',
  disabled = false,
}) => {
  const classes = classnames(className, style['base-tab-button'], {
    [style.selected]: selected,
    [selectedClassName]: selected,
    [style['tab-button']]: theme === 'unstyled',
    [style['file-tab-button']]: theme === 'file-tab',
    [style['wizard-stepper-button']]: theme === 'wizard',
  });
  return (
    <Button className={classes} disabled={disabled} id={id} onClick={onClick} theme='unstyled'>
      {children}
    </Button>
  );
};

DeprecatedTabButton.propTypes = {
  id: PropTypes.string,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  selectedClassName: PropTypes.string,
  theme: PropTypes.oneOf(['file-tab', 'unstyled', 'wizard']),
  disabled: PropTypes.bool,
};
